import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect, withRouter } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

import { actions } from '../services/auth';

const styled = withStyles(theme => {
  return {
    progress: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -20,
      marginLeft: -20
    }
  };
});

class PrivateRoute extends React.Component {
  // componentDidMount() {
  //   if (!this.props.authCheckDone) {
  //     this.props.actions.authCheck();
  //   }
  // }

  render() {
    const { classes, loggedIn, component: Component, ...rest } = this.props;

    // if (!authCheckDone) {
    //   return (
    //     <Route {...rest}>
    //       <CircularProgress color="secondary" className={classes.progress} size="100px" thickness={2.2}/>
    //     </Route>
    //   );
    // }

    return (
      <Route
        {...rest}
        render={props =>
          loggedIn ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: process.env.PUBLIC_URL + '/login',
                state: { from: props.location }
              }}
            />
          )
        }
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    loggedIn: state.auth.data.token ? true : false
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {}
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(styled(PrivateRoute))
);
